import { ReferenceInput, AutocompleteInput } from "react-admin";
import { BusScheduleResources } from "utils/tools";
import { useField } from "react-final-form";

interface IStudentInput {
  isDisable?: boolean;
}

const StudentInput = ({ isDisable }: IStudentInput) => {
  const {
    input: { value },
  } = useField("busScheduleId");

  const busScheduleResource = BusScheduleResources(Number(value));

  return (
    <ReferenceInput
      label="Select Student"
      source="studentId"
      reference="students"
      filter={{
        SchoolId: busScheduleResource ? busScheduleResource.SchoolId : 0,
      }}
      disabled={isDisable}
      filterToQuery={(searchText: any) => {
        if (searchText !== "") return { search: searchText };
      }}
    >
      <AutocompleteInput
        optionText={(choice: any) => `${choice?.firstName} ${choice?.lastName}`}
      />
    </ReferenceInput>
  );
};

export default StudentInput;
